/* tslint:disable */
export * from './OpenErpService';
export * from './OpenErpUser';
export * from './Role';
export * from './Partner';
export * from './PartnerAddress';
export * from './PartnerContact';
export * from './Product';
export * from './ProductCategory';
export * from './ProductCategoryType';
export * from './ProductUom';
export * from './ProductUomCategory';
export * from './PurchaseOrder';
export * from './PurchaseOrderLine';
export * from './PurchaseRequisition';
export * from './PurchaseRequisitionLine';
export * from './CrmClaim';
export * from './CrmCaseStage';
export * from './Company';
export * from './StockPicking';
export * from './StockQuantPackage';
export * from './MoveQualityControl';
export * from './QualityMeasureValue';
export * from './QualityMeasure';
export * from './StockMove';
export * from './StockPickingLine';
export * from './StockLocation';
export * from './StockWarehouseLocation';
export * from './StockWarehouse';
export * from './DeliveryCarrier';
export * from './ClaimLine';
export * from './Users';
export * from './Groups';
export * from './ProductImages';
export * from './GpsPosition';
export * from './ModuleCategory';
export * from './ImageGallery';
export * from './PartnerLerProduct';
export * from './ConfigParameter';
export * from './ResiduePartnerKPI';
export * from './ResiduePartnerKpiType';
export * from './StockProductionLot';
export * from './StockQuant';
export * from './Autologin';
export * from './LerOperatorType';
export * from './LerOperationType';
export * from './FilterSizeAnalysis';
export * from './FilterValuesQualityAnalysis';
export * from './HomogenizationOrder';
export * from './HomogenizationOrderInLine';
export * from './HomogenizationOrderLine';
export * from './HomogenizationOrderOutLine';
export * from './LotConfigurationMpoLine';
export * from './LotQualityAnalysis';
export * from './LotQualityAnalysisImage';
export * from './ManufacturingProductionOrder';
export * from './ManufacturingProductionOrderLine';
export * from './ManufacturingWorkLine';
export * from './ManufacturingWorkShift';
export * from './ProductionOrder';
export * from './ProductionOrderInLine';
export * from './ProductionOrderLine';
export * from './ProductionOrderOutLine';
export * from './BaseModels';




// WEBPACK FOOTER //
// ./src/sdk/models/index.ts